import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgSchoonHeelVeilig = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      d="M24.91 8A5.32 5.32 0 0 0 20 11.16 5.32 5.32 0 0 0 15.09 8c-3.68 0-5.89 3.39-5.89 6.18C9.2 18.86 20 26 20 26s10.8-7.13 10.8-11.82c0-2.79-2.21-6.18-5.89-6.18"
    />
    <path
      fill="#F170B8"
      d="M9.44 21.71V20A2.29 2.29 0 1 1 14 20v1.71H6.64a.65.65 0 0 0-.64.65v9a.64.64 0 0 0 .64.64h10.15a.64.64 0 0 0 .64-.64v-9a.65.65 0 0 0-.64-.65h-1.08V20a4 4 0 1 0-8 0v1.71"
    />
    <path
      fill="#F8BADD"
      d="M13.43 25.71A1.72 1.72 0 1 0 11 27.26l-.41 2.45h2.29l-.41-2.45a1.71 1.71 0 0 0 .96-1.55M22.22 25.8c.47-1.66 2.94-2.91 5.38-2.23s3.9 3 3.43 4.7l-.47 1.56-8.81-2.46z"
    />
    <path
      fill="#F170B8"
      d="M27.6 23.57c-2.44-.68-4.91.57-5.38 2.23l-1.56 5.6 1.52.43 1.87-3.72-.34 4.14 5.75 1.61L31 28.27c.5-1.67-1-4.02-3.4-4.7"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m31.767 12.151-4 12.61-.953-.302 4-12.61z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgSchoonHeelVeilig);

export default ForwardRef;
